import { render, staticRenderFns } from "./PobUpdateModel.vue?vue&type=template&id=212be47e&scoped=true&"
import script from "./PobUpdateModel.vue?vue&type=script&lang=js&"
export * from "./PobUpdateModel.vue?vue&type=script&lang=js&"
import style0 from "./PobUpdateModel.vue?vue&type=style&index=0&id=212be47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212be47e",
  null
  
)

export default component.exports